export default {
  set(style, key, value) {
    style[key] = value;
  },
};



/** WEBPACK FOOTER **
 ** ../src/utils/autoPrefix.js
 **/